"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Game = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

require("./Game.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Helpers
var apiFolder = function apiFolder(game) {
  var prefix = process.env.REACT_APP_API;

  if (game.webapp_storage_type !== "wasabi") {
    prefix = process.env.REACT_APP_API_QA;
  }

  return prefix;
}; // Game


var Game = function Game(_ref) {
  var game = _ref.game;
  var homeTeamScore = game ? game.home_team.score : null;
  var awayTeamScore = game ? game.away_team.score : null;
  var awayTeamTitle = game ? game.away_team.title : null;
  var tm = game ? game.home_team.name : null;
  var gwid = game ? "".concat(game.home_team.name, "-").concat(game.game_id) : null;
  var gameImageUrl = tm && gwid ? "".concat(process.env.REACT_APP_API, "/teams/").concat(tm, "/games/").concat(gwid, "/poster.jpg") : "";
  var gameLink = game ? "".concat(process.env.REACT_APP_GO_TRACEUP, "/#/").concat(game.home_team.name, "/games/").concat(game.game_id, "/goals/1") : "";
  var scoreText = awayTeamScore && homeTeamScore ? "".concat(homeTeamScore, ":").concat(awayTeamScore, " ") : "";
  var topText = game ? "".concat(scoreText, "vs ").concat(awayTeamTitle) : "";
  var bottomText = game ? (0, _moment.default)(game.full_date).calendar() : "";
  var churned = game && game.home_team && game.home_team.content_access ? ["auto_denied", "manual_denied"].includes(game.home_team.content_access) : false;
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    tag: "a",
    href: gameLink,
    className: "GamesListGame",
    "data-trk-act": "Recent Game Link Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    marginBottom: "4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "img-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: gameImageUrl,
    height: "48px",
    width: "80px"
  }), churned && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "churned-overlay"
  }), churned && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    className: "churned-icon",
    type: _atoms.Icon.Type.Lock,
    color: _atoms.Color.White2
  })), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "text-container",
    marginLeft: "2",
    justifyContent: "center"
  }, awayTeamTitle && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "text-top",
    type: _atoms.Label.Type.Body,
    color: _atoms.Color.Trace,
    bold: true
  }, topText), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.SmallBody,
    color: _atoms.Color.Grey1
  }, bottomText))));
};

exports.Game = Game;